import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from 'createHistory';

import { companiesApi } from 'services/companies';
import { analyticsApi } from 'services/analytics';
import { networkApi } from 'services/network';
import { networkV2Api } from 'services/networkV2';
import { contactsApi } from '../../services/contacts';
import { hiresApi } from '../../services/hires';
import { hiresV2Api } from '../../services/hiresV2';
import { networkAdminsApi } from '../../services/networkAdmins';
import { tagsApi } from '../../services/tags';
import { skillsApi } from '../../services/skills';
import { locationsApi } from '../../services/locations';
import { organizationApi } from '../../services/organizations';
import { apiKeysApiV2 } from '../../services/apiKeysV2';
import { organizationApiV2 } from '../../services/organizationsV2';
import networks from './networksReducer';
import user from './userReducer';
import page from './pageReducer';
import jobFunctions from './jobFunctionsReducer';
import loadingReducer from './loadingReducer';
import mainMenuReducer from '../../features/mainMenu';
import listReducer from '../../features/list';
import listsNavTreeUIReducer from '../../features/listsNavTreeUI';
import settingsMenuReducer from '../../features/settingsMenu';
import { contactsV2Api } from '../../services/contactsV2';
import { companiesV2Api } from '../../services/companiesV2';
import { userApi } from '../../services/user';
import { jobsV2Api } from '../../services/jobsV2';
import { matchesApi } from '../../services/matches';
import { connectJobsAPI } from '../../services/connectJobs';
import { searchApi } from '../../services/search';
import { sharedListsApi } from '../../services/sharedLists';
import { sharedListsApiV2 } from '../../services/sharedListV2';
import { sharedListViewsV2Api } from '../../services/sharedListViewsV2';
import { userApi2 } from '../../services/userV2';
import { networkAdminsApiV2 } from '../../services/networkAdminV2';
import { introsV2Api } from '../../services/intros';
import { sharedCompanyListV2Api } from '../../services/sharedCompanyListV2';
import { uploadFileV2Api } from '../../services/uploadFileV2';
import { authApi } from '../../services/auth';
import { alliesApi } from '../../services/allies';
import { customFieldsV2Api } from '../../services/customFieldsV2';
import { listsTreeApi } from '../../services/listsTree';
import { companyAtsApi } from '../../services/companyAtsV2';
import { userGoogleAccountsApi } from '../../services/userGoogleAccountsV2';
import { connectionPathsV2Api } from '../../services/connectionPathsV2';
import { sourcingApi } from '../../services/sourcing';
import { findemApiV2 } from '../../services/findemV2';

export default function createReducer(injectedReducers = {}) {
  return combineReducers({
    loading: loadingReducer,
    jobFunctions,
    networks,
    user,
    page,
    router: connectRouter(history),
    mainMenu: mainMenuReducer,
    list: listReducer,
    listsNavTreeUI: listsNavTreeUIReducer,
    settingsMenu: settingsMenuReducer,
    [contactsApi.reducerPath]: contactsApi.reducer,
    [tagsApi.reducerPath]: tagsApi.reducer,
    [networkAdminsApi.reducerPath]: networkAdminsApi.reducer,
    [networkAdminsApiV2.reducerPath]: networkAdminsApiV2.reducer,
    [organizationApiV2.reducerPath]: organizationApiV2.reducer,
    [hiresApi.reducerPath]: hiresApi.reducer,
    [hiresV2Api.reducerPath]: hiresV2Api.reducer,
    [companiesApi.reducerPath]: companiesApi.reducer,
    [analyticsApi.reducerPath]: analyticsApi.reducer,
    [contactsV2Api.reducerPath]: contactsV2Api.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [userApi2.reducerPath]: userApi2.reducer,
    [jobsV2Api.reducerPath]: jobsV2Api.reducer,
    [companiesV2Api.reducerPath]: companiesV2Api.reducer,
    [matchesApi.reducerPath]: matchesApi.reducer,
    [skillsApi.reducerPath]: skillsApi.reducer,
    [locationsApi.reducerPath]: locationsApi.reducer,
    [connectJobsAPI.reducerPath]: connectJobsAPI.reducer,
    [searchApi.reducerPath]: searchApi.reducer,
    [sharedListsApi.reducerPath]: sharedListsApi.reducer,
    [sharedListsApiV2.reducerPath]: sharedListsApiV2.reducer,
    [sharedListViewsV2Api.reducerPath]: sharedListViewsV2Api.reducer,
    [networkApi.reducerPath]: networkApi.reducer,
    [networkV2Api.reducerPath]: networkV2Api.reducer,
    [introsV2Api.reducerPath]: introsV2Api.reducer,
    [sharedCompanyListV2Api.reducerPath]: sharedCompanyListV2Api.reducer,
    [listReducer.reducerPath]: listReducer.reducer,
    [uploadFileV2Api.reducerPath]: uploadFileV2Api.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [apiKeysApiV2.reducerPath]: apiKeysApiV2.reducer,
    [organizationApi.reducerPath]: organizationApi.reducer,
    [alliesApi.reducerPath]: alliesApi.reducer,
    [customFieldsV2Api.reducerPath]: customFieldsV2Api.reducer,
    [listsTreeApi.reducerPath]: listsTreeApi.reducer,
    [companyAtsApi.reducerPath]: companyAtsApi.reducer,
    [userGoogleAccountsApi.reducerPath]: userGoogleAccountsApi.reducer,
    [connectionPathsV2Api.reducerPath]: connectionPathsV2Api.reducer,
    [sourcingApi.reducerPath]: sourcingApi.reducer,
    [findemApiV2.reducerPath]: findemApiV2.reducer,
    ...injectedReducers,
  });
}
